import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-baa22112"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_7 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_8 = { class: "dropdown profile-dropdown" }
const _hoisted_9 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user custom-icon" }, null, -1))
const _hoisted_11 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_12 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_13 = { class: "text-body-emphasis fw-semibold fs-13" }
const _hoisted_14 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_15 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_16 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-2" }, null, -1))
const _hoisted_18 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-lock" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: _ctx.isSticky },
    ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentUser?.username), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.currentUser?.firstName) + " " + _toDisplayString(_ctx.currentUser?.lastName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                _createElementVNode("li", _hoisted_16, [
                  _hoisted_17,
                  _createTextVNode(" Mi Perfil "),
                  _createVNode(_component_router_link, {
                    to: `/profile/${_ctx.currentUser?.id}`,
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  }, null, 8, ["to"])
                ]),
                _createElementVNode("li", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" Cambiar contraseña "),
                  _createVNode(_component_router_link, {
                    to: `/settings-change-password/${_ctx.currentUser?.id}`,
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  }, null, 8, ["to"])
                ]),
                _createElementVNode("li", {
                  class: "text-body-secondary fw-semibold transition position-relative",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
                }, [
                  _hoisted_20,
                  _createTextVNode(" Cerrar Sesión "),
                  _createVNode(_component_router_link, {
                    to: "",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21,
                      _hoisted_22
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}